import { Component, Inject } from '@angular/core';
import { LookupModel } from '../../../api/models';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { EditWorkflowEventDialogComponent } from '../../../events-flow/edit/node-parameters/edit-workflow-event-dialog-component/edit-workflow-event-dialog-component.component';
import { FlexModule } from '@angular/flex-layout';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatSimpleSelectComponent } from '../../../editors/mat-simple-select/mat-simple-select.component';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';

export interface CloneRoleDialogData {
  selectOptions: LookupModel[];
}

@Component({
    selector: 'app-clone-role-dialog',
    templateUrl: './clone-role-dialog.component.html',
    styleUrls: ['./clone-role-dialog.component.scss'],
    standalone: true,
    imports: [
        MatDialogTitle,
        FlexModule,
        CdkScrollable,
        MatDialogContent,
        MatSimpleSelectComponent,
        FormsModule,
        MatDialogActions,
        MatButton,
        MatDialogClose,
    ],
})
export class CloneRoleDialogComponent {
  public roleId = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: CloneRoleDialogData,
    private readonly _dialogRef: MatDialogRef<EditWorkflowEventDialogComponent>,
  ) {}

  public onClone(): void {
    this._dialogRef.close(this.roleId);
  }
}
